import React, { PropTypes } from 'react';
import FullScreenOverlay from '@bibliocommons/base-full-screen-overlay';
import { childrenShape } from '@bibliocommons/bc-prop-types';

import './AddTitleOverlay.scss';

// this Component is used to add styling to the AddTitle component
export function AddTitleOverlay(props) {
  return (
    <FullScreenOverlay open={props.open} handleClose={props.handleClose} handleFocusOnRestore={props.handleFocusOnRestore} disableHistoryControls className="cp-add-title-overlay" >
      {props.children}
    </FullScreenOverlay>
  );
}

AddTitleOverlay.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  children: childrenShape,
  handleFocusOnRestore: PropTypes.func
};

export default AddTitleOverlay;



// WEBPACK FOOTER //
// ./app/components/shared/AddTitle/AddTitleOverlay.jsx